import { Card, Modal } from 'react-bootstrap'
import AdvertiserSearch from '../../../components/AdvertiserSearch/AdvertiserSearch'
import { useEffect, useState } from 'react'
import callAPI from '../../../helpers/callAPI'

const CreatePitchModalContent = ({ closeModal, initAdvertiser }) => {
    const [advertiser, setAdvertiser] = useState(false)

    const handleCreatePitch = async () => {
        const response = await callAPI('advertisers/ratePitch', 'POST', { advertiserId: advertiser.id})
        if (response.success) {
            console.log('Rate pitch created successfully')
            closeModal()
        }
    }

    useEffect(() => { 
        if (initAdvertiser) {            
            setAdvertiser(initAdvertiser)
        }
     }, [initAdvertiser])    

    return (
        <>
            <Modal.Header closeButton>
                <Modal.Title>Create Rate Pitch</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex m-2 align-items-center">
                    <span className="w-25">Advertiser</span>
                    <div className="w-75">
                        <AdvertiserSearch setAdvertiser={setAdvertiser} advertiser={advertiser} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" onClick={() => handleCreatePitch()}>Create Pitch</button>
            </Modal.Footer>
        </>
    )
}
export default CreatePitchModalContent